import { useRoute, useRouter } from '#imports'
import type { Ref } from 'vue'
import { computed } from 'vue'

export function useSearchQueryParam(): Ref<string> {
  const route = useRoute()
  const router = useRouter()

  const query = computed({
    get: () =>
      (Array.isArray(route.query.q) ? route.query.q[0] : route.query.q) ?? '',
    set: (value: string) => {
      router.replace({
        ...route,
        query: { ...route.query, q: value || undefined },
      })
    },
  })

  return query
}
